import { useMemo } from 'react';
import { useGetQuestionAnswerQuery } from '@graphql/generated';

const useQuestionAnswer = () => {
  const { data } = useGetQuestionAnswerQuery();
  return useMemo(() => ({ questionAnswers: data?.questionAnswers || [] }), [data]);
};

export default useQuestionAnswer;
